import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'visible',
  pure: false,
})
export class Visible implements PipeTransform {
  transform(value: any[]) {
    value = value?.filter((item: { hide: any }) => {
      return !item.hide;
    });
    const newArray = value ? [...value] : []; // or else can do cloning.
    return newArray;
  }
}
